import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
// import { environment } from 'environments/environment';

@Injectable()
export class ConfigService {
  config: IConfig;

  constructor() {
    this.config = <IConfig>{
      apiUrl: environment.apiUrl,
      traslatorApiUrl: environment.traslatorApiUrl,
      notificationsApiUrl: environment.notificationsApiUrl,
      apiPublicUrl: environment.publicApiUrl,
      webExternalUrl: environment.webExternalUrl
    };
  }
}
export interface IConfig {
  apiUrl: string;
  traslatorApiUrl: string;
  notificationsApiUrl: string;
  apiPublicUrl: string;
  webExternalUrl: string;
}
